import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";

export const ElderlyTypesConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/elderly-types",
    component: React.lazy(() => import("./elderly-types")),
  },
];
